export default "__VITE_ASSET__BhZF9EqM__"